<div class="backup-container" [ngClass]="{'disabled': isLoading}">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>
  <div class="form-section pr-10">


    <form [formGroup]="backupForm" class="p-8">

      <div class="flex flex-row gap-8">
      <div class="flex flex-col mb-24 date">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.BACKUP_TYPE' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.BACKUP_TYPE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <div *ngIf="isExtendBackup; else editableBackupType" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
          {{ form.backupType || '-' }}
        </div>
        <ng-template #editableBackupType>
        <mat-select class="backup-type pt-2" #matSelect [placeholder]="'DB_DETAILS.CHOOSE_BACKUP_TYPE' | transloco" [formControl]="backupForm.get('backupType')" (selectionChange)="onRadioButtonChange()">
          <mat-option *ngFor="let backupType of backupTypes" [value]="backupType?.value">{{backupType?.name}}</mat-option>
        </mat-select>
        </ng-template>
        <app-error [control]="backupForm.get('backupType')"></app-error>
      </div>

      <div class="flex flex-col mb-24 date">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">
            {{ (!showRtnType ? 'DB_DETAILS.BACKUP_INTERVAL' : 'DB_DETAILS.RETENTION') | transloco | uppercase }}
          </label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="!showRtnType ? ('DB_DETAILS.BACKUP_INTERVAL' | transloco) : ('DB_DETAILS.RETENTION' | transloco)"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <div *ngIf="isExtendBackup; else editableBackupInterval" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
          {{ form.backupInterval || '-' }}
        </div>
        <ng-template #editableBackupInterval>
        <mat-select class="backup-type pt-2" #matSelect [placeholder]="!showRtnType ? ('DB_DETAILS.CHOOSE_BACKUP_INTERVAL' | transloco) : ('DB_DETAILS.CHOOSE_RETENTION' | transloco)" [formControl]="backupForm.get('backupInterval')" (selectionChange)="selectionChanged()">
          <mat-option *ngFor="let backupInterval of filteredBackupIntervals" [value]="backupInterval?.value">{{backupInterval?.name}}</mat-option>
        </mat-select>
      </ng-template>
      <app-error [control]="backupForm.get('backupInterval')"></app-error>
      </div>

      </div>

      <div *ngIf="!isExtendBackup" class="flex flex-col mb-24">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'DB_DETAILS.DATABASE_TYPE' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'DB_DETAILS.DATABASE_TYPE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <div class="flex items-center">
          <mat-select class="backup-dropdown pt-0" #matSelect [placeholder]="'DB_DETAILS.CHOOSE_DATABASE_TYPE' | transloco" [formControl]="backupForm.get('type')" (selectionChange)="componentSelected()">
            <mat-option *ngFor="let dyType of groupedData" [value]="dyType.type">{{dyType.type.split('/')[0]}}</mat-option>
          </mat-select>
        </div>
        <app-error [control]="backupForm.get('type')"></app-error>
      </div>

      <div *ngIf="isExtendBackup" class="flex flex-col mb-24">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'DB_DETAILS.NAME' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'DB_DETAILS.NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div *ngIf="isExtendBackup" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
          {{form?.backupType === 'archive' && form?.to?.fileName ? form?.to?.fileName : form?.backupType === 'snapshot' && form?.to?.databaseName ? form?.to?.databaseName : '-'}}
        </div>
      </div>

      <div class="flex flex-col mb-24">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'DB_DETAILS.SERVER_NAME' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'DB_DETAILS.SERVER_NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <div *ngIf="isExtendBackup; else editableServer" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
        {{ form.to?.serverName || '-' }}
        </div>
        <ng-template #editableServer>
        <mat-select class="backup-dropdown pt-0" #matSelect [placeholder]="'DB_DETAILS.CHOOSE_SERVER_NAME' | transloco" [formControl]="backupForm.get('serverName')" (selectionChange)="onServerSelected()">
          <mat-option *ngFor="let serverName of  serverNames" [value]="serverName.name">{{serverName.name}}</mat-option>
        </mat-select>
        </ng-template>
        <app-error [control]="backupForm.get('serverName')"></app-error>
      </div>

      <div *ngIf="componentDatabases?.length > 0 && !isPostgres" class="flex flex-col mb-24">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.DATABASE_NAME' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.DATABASE_NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <div *ngIf="isExtendBackup; else editableDatabase" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
        {{ form.snapshotDatabaseName || '-' }}
        </div>
        <ng-template #editableDatabase>
        <mat-select class="backup-dropdown pt-0" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE_DATABASE' | transloco" [formControl]="backupForm.get('databaseName')" (selectionChange)="selectionChanged()">
          <mat-option *ngFor="let database of componentDatabases" [value]="database">{{database}}</mat-option>
        </mat-select>
        </ng-template>
        <app-error [control]="backupForm.get('databaseName')"></app-error>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col bp-date date">
          <div class="mat-subtitle-1 fw-700 fs-12 mb-0 flex items-center date-header">{{'INSTANCE_DETAILS.POINT_IN_TIME' | transloco | uppercase }}
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.POINT_IN_TIME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
          </div>
          <div *ngIf="isExtendBackup; else editablePIT" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
              {{ form.pitrTimestamp ? (form.pitrTimestamp | date:'M/d/yyyy') : '-' }}
        </div>
        <ng-template #editablePIT>
          <mat-form-field class="example-full-width" [ngClass]="{'error-part': pitrDateError}">
            <input matInput [matDatepicker]="picker" (dateChange)="pitrDateChange($event)" (click)="picker.open()" (selectionChange)="selectionChanged()" [min]="instanceCreated" [max]="today" [placeholder]="'INSTANCE_DETAILS.CHOOSE' | transloco" [value]="pitrDate" readonly>
            <mat-datepicker-toggle matIconSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          </ng-template>
          <div class="error-msg fs-12" *ngIf="pitrDateError">Required</div>
        </div>
        <div class="flex flex-col mb-16 hr-mm">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.HH' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.HOURS' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
          </div>
          <div *ngIf="isExtendBackup; else editableHour" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
          {{ form.pitrTimestamp ? (form.pitrTimestamp | date: 'HH') : '-' }}
          </div>
          <ng-template #editableHour>
          <mat-select class="backup-dropdown pt-0" [ngClass]="{'hours': backupForm.get('hour')?.value}" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE' | transloco" [formControl]="backupForm.get('hour')" (selectionChange)="selectionChanged()">
            <mat-option *ngFor="let item of [].constructor(24); let i = index" [value]="i">{{i < 10 ? '0' + i : i}}</mat-option>
          </mat-select>
          </ng-template>
          <app-error [control]="backupForm.get('hour')"></app-error>
        </div>
        <div class="flex flex-col mb-16 hr-mm">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.MM' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.MINUTES' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            <span *ngIf="!isExtendBackup" class="mandatory mt--12 mat-body-2">*</span>
          </div>
          <div *ngIf="isExtendBackup; else editableMins" class="flex items-center px-4 py-3 fs-16 fw-500 display-box">
          {{ form.pitrTimestamp ? (form.pitrTimestamp | date: 'mm') : '-' }}
          </div>
          <ng-template #editableMins>
          <mat-select class="backup-dropdown pt-0" [ngClass]="{'mins': backupForm.get('minute')?.value}" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE' | transloco" [formControl]="backupForm.get('minute')" (selectionChange)="selectionChanged()">
            <mat-option *ngFor="let item of [].constructor(60); let i = index" [value]="i">{{i < 10 ? '0' + i : i}}</mat-option>
          </mat-select>
          </ng-template>
          <app-error [control]="backupForm.get('minute')"></app-error>
        </div>
      </div>

      <div class="flex flex-row gap-8">
      <div *ngIf="showRtnDate || isExtendBackup" class="flex flex-col date bp-date">
        <div class="mat-subtitle-1 fw-700 fs-12 mb-0 flex items-center date-header">{{'INSTANCE_DETAILS.RETENTION_DATE' | transloco | uppercase }}
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.RETENTION_DATE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <mat-form-field class="example-full-width" [ngClass]="{'error-part': rtnDateError, 'disable': !isExtendBackup && !pitrDate}" >
          <input matInput [matDatepicker]="picker1" (dateChange)="rtnDateChange($event)" [disabled]= "!isExtendBackup && !pitrDate" [min]="tomorrow" [max]="rtnEndDate" [matDatepickerFilter]="disableOldDates" (click)="picker1.open()" [placeholder]="'INSTANCE_DETAILS.CHOOSE' | transloco" [value]="rtnDate" readonly>
          <mat-datepicker-toggle matIconSuffix [for]="picker1">
            <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <div class="error-msg fs-12" *ngIf="rtnDateError">Required</div>
      </div>

      <div class="flex flex-col mb-16" [ngClass]="(showRtnDate || isExtendBackup) ? 'date' : 'jira-ticket'">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.JIRA_TICKET_NUMBER' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.JIRA_TICKET_NUMBER' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span class="mandatory mt--12 mat-body-2">*</span>
        </div>
        <input formControlName="ticketNumber" placeholder="{{'INSTANCE_DETAILS.JIRA_TICKET_NUMBER' | transloco}}" class="fw-500" required (keyup)="selectionChanged()" id="ticket">
        <app-error [control]="backupForm.get('ticketNumber')"></app-error>
      </div>
      </div>
    </form>
  </div>
  <span class="flex-auto mb-10"></span>
  <mat-divider class="neutral-2 mt-16 mb-16"></mat-divider>
  <div class="footer pt-16" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" [ngClass]="{'disable': disableSubmit}" type="button" (click)="isExtendBackup ? extendBackup() : createDeployment()">{{'ADD_SOLUTION.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>

<div class="flex items-center justify-center loader" *ngIf="isLoading">
  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>

